/*
 * @Author: amy
 * @Date: 2021-04-21 10:44:30
 * @LastEditTime: 2022-06-20 17:35:21
 * @Description: file content
 */
import { request } from '@/utils/request'

// 获取项目树信息
export function getProjectTree(data) {
  return request({
    url: '/org/project-chose',
    method: 'POST',
    data
  })
}

// 根据项目查企业
export function getProjectFindEnt(params) {
  return request({
    url: '/project/find-ent',
    method: 'GET',
    params
  })
}

// 获取企业个性化配置
export function getEnterpriseConfigDetail(params) {
  return request({
    url: '/enterprise-config/get-ent-conf',
    method:'GET',
    params
  })
}

/**
 * 根据企业id获取企业设置的超时会话时间
 * @param {*} params 
 * @returns 
 */
 export function queryEnterpriseSesstionTime(params) {
  return request({
    url: '/enterprise-config/session-time/get',
    method:'GET',
    params
  })
}
/**
 * 获取企业选择器数据列表
 * 在线接口文档地址：http://172.17.1.177:3000/project/53/interface/api/36943
 * @param {*} data 
 * @returns 
 */
export function queryEntList(data) {
  return request({
    url: '/ent/chose',
    method: 'POST',
    data
  })
}
/**
 * 获取项目列表数据
 * 在线接口文档地址：http://172.17.1.177:3000/project/53/interface/api/36915
 * @param {*} data 
 * @returns 
 */
export function queryProjectList(data) {
  return request({
    url: '/org/project-chose/v3',
    method: 'POST',
    data
  })
}